import { render, staticRenderFns } from "./fireFightingReceivingSetHistory.vue?vue&type=template&id=38bfedec"
import script from "./fireFightingReceivingSetHistory.vue?vue&type=script&lang=js"
export * from "./fireFightingReceivingSetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bfedec')) {
      api.createRecord('38bfedec', component.options)
    } else {
      api.reload('38bfedec', component.options)
    }
    module.hot.accept("./fireFightingReceivingSetHistory.vue?vue&type=template&id=38bfedec", function () {
      api.rerender('38bfedec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/receiving/fireFightingReceivingSetHistory.vue"
export default component.exports